<template>
  <div class="panel">
    <div class="content-group text-center" style="margin-bottom: 0!important">
      <span class="display-inline-block">
        <img :src="blogItem.image" class="img-responsive" alt="">
      </span>
    </div>
    <div class="panel-body">
      <div class="content-group-lg">
        <ul class="list-inline list-inline-condensed no-margin-bottom">
          <li v-for="tag in blogItem.tags">
              <span class="label border-left-blue label-striped content-group">{{tag}}</span>
          </li>
        </ul>
        <h3 class="text-semibold mb-5 blog-title">
          <a href="#" class="text-default">{{blogItem.title}}</a>
        </h3>

        <ul class="list-inline list-inline-separate text-muted content-group">
          <li>{{formatedDate}} | Day {{blogItem.day}}</li>
        </ul>

        <div v-if="blogItem.preview && !showFullPost" class="content-group" v-html="blogItem.preview"></div>
        <div v-else class="content-group" v-html="blogItem.content"></div>
        <vue-disqus ref="disqus" v-if="showFullPost" shortname="pursuing-business" :identifier="blogItem.id" :url="`https://pursuing.business/post/${blogItem.id}`"/>
        <div class="panel-footer">
          <div class="heading-elements-footer">
            <a type="button" v-if="!showFullPost"
               :href="`https://www.facebook.com/sharer/sharer.php?u=https://pursuing.business/post/${blogItem.id}`"
               target="_blank" class="btn btn-primary btn-icon"><i
              class="fab fa-facebook-square"></i></a>
            <a type="button" v-if="!showFullPost"
               target="_blank"
               :href="`https://twitter.com/intent/tweet?text=Starting%20Business%20from%20Zero:%20${encodeURIComponent(blogItem.title)}%0Ahttps://pursuing.business/post/${blogItem.id}`"
               class="btn btn-info btn-icon"><i class="fab fa-twitter-square"></i></a>
            <!--<a type="button" class="btn btn-default btn-icon text-muted" @click="updateLike">-->
              <!--<i class="fa-heart text-size-base text-pink position-left" :class="{'fas': postLiked, 'far': !postLiked}"></i> {{ blogItem.likes }}</a>-->
            <a type="button" v-if="!showFullPost" class="btn btn-default btn-icon text-muted" @click="togglePost">
              <i class="far fa-comment text-size-base text-pink position-left"></i> Comments</a>
            <a type="button" v-if="loggedIn && blogItem.owner === getUser.uid"
               @click="removeItem" class="btn btn-warning btn-icon"><i
              class="fas fa-trash"></i></a>
            <div class="heading-btn pull-right">
              <a v-if="blogItem.preview && !showFullPost" class="heading-text pull-right" @click="togglePost">Read more <i
                class="fas fa-arrow-right position-right"></i></a>
              <a v-if="showFullPost" class="heading-text pull-right" @click="togglePost">Hide <i
                class="fas fa-angle-up position-right"></i></a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import swal from 'sweetalert2'
  import moment from 'moment'
  import db from '../../db.js'
  import VueDisqus from './VueDisqus.vue'

  export default {
    name: 'blog-item',
    components: {
      VueDisqus
    },
    props: {
      blogItem: {
        type: Object,
        default: {}
      },
      postId: {
        type: String,
        default: null
      },
      postToggled: {
        type: Number,
        default: 0
      }
    },
    watch: {
      postToggled: {
        handler () {
          if (this.activePost) {
            this.showFullPost = !this.showFullPost
            this.activePost = false
            this.$ga.event({
                eventCategory: 'Post',
                eventAction: 'Opened',
                eventValue: this.blogItem.title
            })
            return;
          }
          if (this.showFullPost) {
            this.showFullPost = false
          }
        }
      }
    },
    firebase: {
      blogItems: db.ref('blog-items/public')
    },
    data () {
      return {
        activePost: false,
        showFullPost: (this.postId),

      }
    },
    computed: {
      ...mapState(['mode', 'loggedIn']),
      ...mapGetters(['getUser']),
      formatedDate () {
        return moment(this.blogItem.date).format("MMMM Do YYYY");
      }
    },
    methods: {
      togglePost () {
        this.activePost = true
        this.$emit('togglePost')
      },
      removeItem() {
        const item = this.blogItem
        if (item.owner === this.getUser.uid) {
          itemsRef[this.mode].child(item['.key']).remove();

          swal(
            'OK!',
            'Post removed',
            'success')
        } else {
          swal(
            'Ups!..',
            "You don't own this puzzle",
            'info')
        }
      }
    }
  }
</script>

<style scoped>
  .panel-footer > .heading-elements-footer > .pull-right {
    float: right!important;
  }
  .heading-elements-footer {
    display: block!important;
  }
</style>



// WEBPACK FOOTER //
// BlogItem.vue?58ec72a2